function setImmediate(callback: () => void) {
    return Promise.resolve().then(() => {
        callback();
    });
}

export default setImmediate;
